import React from 'react'

const UpdateItem29Okt2024 = ({date, lastUpdate, onClick, activeUpdateText, id}) => {
    const additionalClass = lastUpdate ? 'update-text-open' : activeUpdateText === id ? 'update-text-open' : 'update-text-close' 

    return (
        <div className={"" + additionalClass}>
            {onClick ? (<p onClick={()=>onClick(additionalClass, id)} className="update-title cursor-pointer title-large-color gap-10">{date}</p>)
            :
            (<p className="title-large-color gap-10">{date}</p>)}
            <div className="update-text-content">
                <p className="text-regular-color text-regular-uppercase gap-20">
                    NEUES FEATURE / NEW FEATURE
                </p>
                <div className='gap-35'>
                    <p className="text-regular orange uppercase gap-10">
                        Neue Suchfunktion in der Programmübersicht<br/>
                        <span className='grey'>New search function in the programme overview</span>
                    </p>
                    <div className='flex-container gap-20'>
                        <div>
                            <p className="text-regular gap-10">
                                Mit unserer neuen, praktischen Suchfunktion finden Ihre Kinobesucher im Handumdrehen alle Filme im Programm. Die Freitextsuche lässt sich ganz einfach mit den bestehenden Filtern kombinieren – so wird die Filmauswahl zum Kinderspiel!<br/>
                                <span className='grey'>
                                With our new, practical search function, your cinema visitors will find all the films in the programme in no time at all. The free text search can be easily combined with the existing filters - making film selection child's play!
                                </span>
                            </p>
                        </div>
                    </div>
                    <p className="text-regular uppercase orange gap-10">
                        Unser Kino-Chatbot für zufriedene Gäste<br/>
                        <span className='grey'>Our cinema chatbot for happy guests</span>
                    </p>
                    <div className='grid-container row gap-20'>
                        <div>
                            <p className="text-regular gap-10">
                            Für eine rundum gelungene Betreuung bietet unser Chatbot eine schnelle Hilfe für Ihre Besucher. Er beantwortet Fragen, entlastet Ihr Team und sorgt für glückliche Kinogäste. Gerne passen wir die Inhalte, Persönlichkeit und Tonalität des Chatbots individuell an Ihr Kino an.<br/>
                                <span className='grey'>
                                Our chatbot offers quick help for your visitors for all-round successful support. It answers questions, relieves your team and ensures happy cinema guests. We are happy to customise the content, personality and tone of the chatbot to suit your cinema.
                                </span>
                            </p>
                        </div>
                    </div>
                    <div className='grid-container row gap-20'>
                        <div>
                            <p className="text-regular gap-10">
                            Interesse? Kontaktieren Sie uns für ein persönliches Angebot unter <a href="mailto:info@pmkino.com">info@pmkino.com</a>.<br/>
                                <span className='grey'>Interested? Contact us for a personalised offer at <a href="mailto:info@pmkino.com">info@pmkino.com</a>.</span>
                            </p>
                        </div>
                    </div>
                </div>

                <p className="text-regular-color text-regular-uppercase">
                    BUGFIX
                </p>
                <div className='gap-35'>
                    <p className="text-regular gap-10">
                    Wir haben ein paar Logik- und Schönheitsfehler ausgebessert. <br/>
                        <span className='grey'>We have fixed a few logical and cosmetic errors.</span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default UpdateItem29Okt2024